import type { CardPointeGatewayId } from './cardpointe-system-constants';

export const CardPointeFrontendConfigEditingOutcome = {
    APPLIED: 'applied',
    INVALID_CONFIGURATION: 'invalid_configuration',
} as const;

export type CardPointeFrontendConfigEditingOutcome =
    (typeof CardPointeFrontendConfigEditingOutcome)[keyof typeof CardPointeFrontendConfigEditingOutcome];

export interface CardPointeFrontendConfigEditorValues {
    readonly enabled: boolean;
    readonly merchantId: string;
    readonly gatewayApiBaseUrl: string;
    readonly terminalApiBaseUrl: string;
    readonly cardSecureTokenizationUrl: string;
}

export interface CardPointeFrontendConfigEditingRequestDetails {
    readonly gatewayId: typeof CardPointeGatewayId;
    readonly editorValues: CardPointeFrontendConfigEditorValues;
}

export interface CardPointeFrontendConfigEditingNormalizedResult {
    readonly gatewayId: typeof CardPointeGatewayId;
    readonly enabled: boolean;
    readonly merchantId: string;
    readonly gatewayApiBaseUrl: string;
    readonly terminalApiBaseUrl: string;
    readonly cardSecureTokenizationUrl: string;
}

export type CardPointeFrontendConfigEditingResponseDetails =
    | {
          readonly outcome: typeof CardPointeFrontendConfigEditingOutcome.APPLIED;
          readonly normalizedResult: CardPointeFrontendConfigEditingNormalizedResult;
      }
    | {
          readonly outcome: typeof CardPointeFrontendConfigEditingOutcome.INVALID_CONFIGURATION;
          readonly message: string;
          readonly body: unknown;
      };
